enum Types {
  Category = '6cfe478a-6ba3-47ef-8cd4-f5167b91f225',
  Name = 'de8e623e-c037-49f3-9520-d54f3d056d2c',
  Content = '1b403374-e4b9-48fd-9411-917e9cdbced7',
  Table = '69c3b7b3-1bc1-4957-b88c-cd513210d982',
  TableCategory = '1070e84e-8e7c-4e64-a842-9d6fe4eb337e',
  TableSection = '8fdfbeeb-5dd1-494a-b0c0-d684d8c92bd8',
  ConnectionType = '19343fa0-9cb0-49e7-ace2-bc1e54095121',
  SectionRule = '3f64593b-4444-434a-a5f5-2bb56d335c73',
  SectionSort = '1b5f7efe-257b-4fe9-8d43-a78afc9d091f',
  SectionGroup = '91dac943-1992-4697-b356-4b467ee761eb',
  Media = '823fe67d-f9e3-44ae-95a5-140fb5fb4e20',
  Original = '048fb3fa-138e-4cd9-8f70-a1278f75f0df',
  Visited = '6f99b896-f17b-4ebf-9545-e0f30fc40e57',
  MimeType = '04bc4407-b5aa-42f3-9432-9ef1fe873a9c',
  MediaType = '65e95bd9-d339-45c0-afed-e3f6de756445',
}

export default Types
